import gsap from "gsap";

export function render() {
  const $loader = document.querySelector(".c-loader");
  const event = new CustomEvent("loader");

  if (!sessionStorage.getItem("loaded")) {
    if ($loader) {
      const icons = Array.from(
        $loader.querySelectorAll(".c-loader__icon")
      ).reverse();
      const number = $loader.querySelector(
        ".c-loader__number span:first-child"
      );

      let rotateIcon = gsap.timeline();
      let loaderAnimation = gsap.timeline();

      gsap.set("body", { overflow: "hidden" });

      icons.forEach((icon, i) => {
        rotateIcon.to(icon, {
          duration: 0.9,
          ease: "linear",
          rotateY: icons[i + 1] ? "+=270" : "+=360",
        });
        if (icons[i + 1]) {
          rotateIcon
            .set(icon, {
              display: "none",
            })
            .set(icons[i + 1], {
              display: "block",
            })
            .to(icons[i + 1], {
              duration: 0.3,
              ease: "linear",
              rotateY: "+=90",
            });
        }
      });

      loaderAnimation
        .to(number, {
          duration: 4.8,
          ease: "Power1.easeOut",
          snap: { textContent: 1 },
          textContent: 100,
        })
        .to("body", { overflow: "initial" }, 4.7)
        .add(() => {
          document.dispatchEvent(event);
        })
        .to(
          $loader,
          {
            ease: "Circ.easeOut",
            duration: 0.8,
            translateY: "-100vh",
          },
          5.2
        );
    }
  } else {
    $loader.style.display = "none";
    document.dispatchEvent(event);
  }
}
